import React from "react";
import { Colors } from "../../utils/colors";

interface RadioButtonProps {
  selected?: boolean;
  onChange?: () => void;
  size?: number;
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  selected = false,
  onChange,
  size = 28,
}) => {
  return (
    <div
      onClick={onChange}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        border: `2px solid ${selected ? Colors.green : Colors.grey}`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
      }}>
      {selected && (
        <div
          style={{
            width: size / 2,
            height: size / 2,
            borderRadius: "50%",
            backgroundColor: Colors.green,
          }}
        />
      )}
    </div>
  );
};
